import { Box, Grid, Skeleton } from "@mui/material";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { FCol } from "../../../../globalComponents/standard";
import ProductDetailsContext from "./context";
import FormInfo from "./formInfo";
import { useProductDetailsManager } from "./useProductDetails";

const ProductDetails = () => {
  const { loading } = useContext(ProductDetailsContext);

  return (
    <Box
      sx={{
        margin: 0,
        height: "100vh", // full screen
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading ? (
        <React.Fragment>
          <FCol>
            <Skeleton height={60} />
            <Skeleton height={30} />
            <Skeleton height={30} />
            <Skeleton height={30} />
            <Skeleton height={70} />
            <Skeleton height={30} />
            <Skeleton height={300} />
          </FCol>
        </React.Fragment>
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <FormInfo />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

const Index = () => {
  const { id } = useParams();
  return (
    <ProductDetailsContext.Provider value={useProductDetailsManager(id)}>
      <ProductDetails />
    </ProductDetailsContext.Provider>
  );
};

export default Index;
